// extracted by mini-css-extract-plugin
export default {"footer":"Table_footer__70J1b"};